import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {User} from "../../models/user.model";
import {Observable} from "rxjs";
import {HelperService} from "../helperService";
import {map} from "rxjs/operators";
import {Config} from "../../models/config.model";
import {TranslateService} from "@ngx-translate/core";


/**
 * Class > UsersService
 */
@Injectable()
export class UsersService
{


	/**
	 * Function > constructor
	 * @param {HttpClient} http_client
	 * @param {HelperService} helper_service
	 * @param translate_service
	 */
	constructor
	(
		private http_client: HttpClient,
		private helper_service: HelperService,
		private translate_service: TranslateService
	) {} // end function constructor


	/**
	 * Function > getAll
	 * @param {string} url_endpoint
	 * @return {Observable<Object>}
	 */
	getAll(url_endpoint: string)
	{
		return this.http_client.get(url_endpoint)
			.pipe(
				map((OBJ_response: Observable<Object>) => OBJ_response)
			);
	} // end function getAll


	/**
	 * Function > getByUsername
	 * @param {string} url_endpoint
	 * @param {string} username
	 * @return {Observable<Object>}
	 */
	getByUsername(url_endpoint: string, username: string)
	{
		return this.http_client.get(url_endpoint + "/" + username)
			.pipe(
				map((response: Observable<Object>) => response)
			);
	} // end function getByUsername


	/**
	 * Function > create
	 * @param {string} url_endpoint
	 * @param {object} user
	 * @return {Observable<Object>}
	 */
	create(url_endpoint: string, user: User)
	{
		let config: Config = this.helper_service.getFromLocalstorage('config');

		let params = {};

		// schicke immer application und Netzwerk mit
		if (config != null && config.application && config.network)
		{
			params = {
				"application": config.application,
				"network": config.network,
				"lang": this.translate_service.currentLang,
			};
		} // end if

		user.username = user.username.toLowerCase(); // email address to lower case
		return this.http_client.post(url_endpoint , user, {params: params})
			.pipe(
				map((response: Observable<Object>) => response)
			);
	} // end function create


	/**
	 * Function > update
	 * @param {string} url_endpoint
	 * @param {string} username
	 * @param {object} user
	 * @return {Observable<Object>}
	 */
	update(url_endpoint: string, username: string, user: User)
	{
		user.username = user.username.toLowerCase(); // email address to lower case
		return this.http_client.put(url_endpoint+"/"+username, user)
			.pipe(
				map((OBJ_response: Observable<Object>) => OBJ_response)
			);
	} // end function update


	/**
	 * Function > delete
	 * @param {string} url_endpoint
	 * @param {string} username
	 * @return {Observable<Object>}
	 */
	delete(url_endpoint: string, username: string)
	{
		return this.http_client.delete(url_endpoint + "/" + username)
			.pipe(
				map((OBJ_response: Observable<Object>) => OBJ_response)
			);
	} // end function delete


	/**
	 * Function > setCurrentUserInLocalStorage
	 * @param data
	 */
	setCurrentUserInLocalStorage(data)
	{

		delete data["password"];
		data["id"] = data["_id"]["$id"];
		delete data["_id"];

		// store user details in local storage to keep user logged in between page refreshes
		this.helper_service.setInLocalstorage('current_user', data);

	} // end function setCurrentUserInLocalStorage


	/**
	 * Function > getCurrentUserFromLocalStorage
	 * @return {User}
	 */
	getCurrentUserFromLocalStorage()
	{
		return this.helper_service.getFromLocalstorage('current_user');
	} // end function getCurrentUserFromLocalStorage


	/**
	 * Function > sendMail
	 * @param {string} url_endpoint
	 * @param {object} data
	 * @return {Observable<Object>}
	 */
	sendMail(url_endpoint: string, data): Observable<any>
	{
		return this.http_client.post(url_endpoint, data)
			.pipe(
				map((OBJ_response: Observable<Object>) => OBJ_response)
			);
	} // end function sendMail

	/**
	 * Function > changePassword
	 * @param {string} url_endpoint
	 * @param {object} data
	 * @return {Observable<Object>}
	 */
	changePassword(url_endpoint: string, data)
	{
		return this.http_client.post(url_endpoint, data)
			.pipe(
				map((OBJ_response: Observable<Object>) => OBJ_response)
			);
	} // end function changePassword

	/**
	 * Function > addGustRoles
	 * @param {string} url_endpoint
	 * @param {object} data
	 * @return {Observable<Object>}
	 */
	addGustRoles(url_endpoint: string, data): Observable<any>
	{
		return this.http_client.post(url_endpoint, data)
		.pipe(
			map((OBJ_response: Observable<Object>) => OBJ_response)
		);
	} // end function addGustRoles


} // end class UsersService
